import { flowApi } from '.';
import type {
  CreateUserFilterReq,
  GetSimpleUserFilterReq,
  GetUserFiltersReq,
  GetUserFiltersRes,
  GetUserFiltersResWithContext,
  UserFilter,
} from 'types/userFilters';

export const userFilters = flowApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    createUserFilter: builder.mutation<UserFilter, CreateUserFilterReq>({
      query: ({ name, agendaId, viewId, values, isDefault, isGlobal, tableId, columnValues }) => ({
        url: `UserFilters`,
        method: 'POST',
        body: {
          name: name,
          agendaId,
          viewId,
          values,
          tableId,
          columnValues,
          isDefault,
          isGlobal,
        },
      }),
    }),
    getUserFilters: builder.query<GetUserFiltersResWithContext, GetUserFiltersReq<null>>({
      query: (params) => ({
        url: `UserFilters`,
        method: 'GET',
        params: params,
      }),
      transformResponse: (response: GetUserFiltersRes, _, arg) => {
        return {
          agendaId: arg.agendaId || '',
          viewId: arg.viewId,
          tableId: arg.tableId || '',
          filters: response,
        };
      },
    }),
    getUserFilterById: builder.query<UserFilter, GetSimpleUserFilterReq>({
      query: ({ userFilterId }) => ({
        url: `UserFilters/${userFilterId}`,
        method: 'GET',
        params: {
          userFilterId: userFilterId,
        },
      }),
    }),
    editUserFilterById: builder.mutation<UserFilter, UserFilter & GetSimpleUserFilterReq>({
      query: ({ userFilterId, ...rest }) => ({
        url: `UserFilters/${userFilterId}`,
        method: 'PUT',
        params: {
          userFilterId: userFilterId,
        },
        body: rest,
      }),
    }),
    deleteUserFilterById: builder.mutation<void, GetSimpleUserFilterReq>({
      query: ({ userFilterId }) => ({
        url: `UserFilters/${userFilterId}`,
        method: 'DELETE',
        params: {
          userFilterId: userFilterId,
        },
      }),
    }),
  }),
});
export const {
  useGetUserFilterByIdQuery,
  useCreateUserFilterMutation,
  useGetUserFiltersQuery,
  useLazyGetUserFilterByIdQuery,
  useLazyGetUserFiltersQuery,
  useDeleteUserFilterByIdMutation,
  useEditUserFilterByIdMutation,
} = userFilters;
